import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import SectionBackground from '../SectionBackground';
import SectionContent from '../SectionContent';

const SectionWrapper = styled.section`
  margin: 0 auto 100px auto;
  max-width: 1450px;
  height: calc(100vh - 90px);
  position: relative;
  width: 100%;

  @media (max-width: 970px) {
    min-height: 450px;
    height: auto;
    margin-bottom: 35px;
  }
`;

const Section = ({
  alt,
  body,
  header,
  imageUrl,
  videoUrl,
  mobileVideoUrl,
  posterUrl,
  matterportUrl,
  title,
  gaLabel,
}) => {
  const getVideoUrl = () => {
    return (typeof window !== 'undefined' && window.innerWidth > 900) ||
      !mobileVideoUrl
      ? videoUrl
      : mobileVideoUrl;
  };
  return (
    <SectionWrapper>
      <SectionContent
        alt={alt}
        title={title}
        header={header}
        body={body}
        matterportUrl={matterportUrl}
        gaLabel={gaLabel}
      />
      <SectionBackground
        alt={alt}
        imageUrl={imageUrl}
        videoUrl={getVideoUrl()}
        posterUrl={posterUrl}
      />
    </SectionWrapper>
  );
};

Section.propTypes = {
  alt: PropTypes.any,
  body: PropTypes.string,
  header: PropTypes.any,
  imageUrl: PropTypes.any,
  videoUrl: PropTypes.any,
  mobileVideoUrl: PropTypes.any,
  posterUrl: PropTypes.any,
  matterportUrl: PropTypes.string,
  title: PropTypes.string,
  gaLabel: PropTypes.string,
};

Section.defaultProps = {
  alt: '',
  body: '',
  header: '',
  imageUrl: null,
  videoUrl: null,
  mobileVideoUrl: null,
  posterUrl: null,
  matterportUrl: '',
  title: '',
  gaLabel: '',
};

export default Section;
